import type { ComponentStyleConfig } from '@chakra-ui/theme';

const FormTheme = {
  Form: {
    baseStyle: {
      helperText: {
        color: 'input/text/helper',
        _disabled: {
          color: 'text/disabled',
        },
        marginTop: '4',

        textStyle: 'comp/input/helperText',
      },
    } as ComponentStyleConfig,
  },
  FormError: {
    baseStyle: {
      text: {
        color: 'input/text/error',
        marginTop: '4',
        textStyle: 'comp/input/helperText',
      },
    } as ComponentStyleConfig,
  },
  FormLabel: {
    baseStyle: {
      _disabled: {
        color: 'text/disabled',
      },
      color: 'input/text/label',
      textStyle: 'comp/input/label',
    } as ComponentStyleConfig,
  },
};

export default FormTheme;
